import {snakify} from '../snakify';
import {camelize} from '../camelize';
import {Role} from '../../models/role';
import {ISerializable} from 'cerialize';
import {InvitationStatus} from '../../models/invitation-status';

export const InvitationStatusTransformer: ISerializable = {
  Serialize(value: InvitationStatus): string {
    return snakify(InvitationStatus[value]);
  },
  Deserialize(json: any): any {
    if (json) {
      const valueName = camelize(json, true);
      return InvitationStatus[valueName];
    }
    return InvitationStatus.Pending;
  }
};
